export default {"src":"/_next/static/media/arrow-down-white.70c4a38e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};